import { Cookies } from 'react-cookie';

import { SiteFormValues } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface updateClientObj {
  id?: number;
  object: SiteFormValues & { isAddTechnician?: boolean };
}

export const updateObject = async (info: updateClientObj) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');

  const requestData = {
    ...info.object,
    manager: info.object.manager ? Number(info.object.manager) : null,
    company: info.object.company ? Number(info.object.company) : null,
  };

  const data = await axiosInterceptor.put(`/objects/${info.id}/`, requestData, {
    headers: { Authorization: token },
  });

  return data.data as any;
};
